module.exports = __webpack_public_path__ + "img/icon4.d7d2b3f2.png";